export default function GetRole(){
    var role = localStorage.getItem("@HSCHOOL_ROLE");
    return role
}